import { render, staticRenderFns } from "./attentionPop.vue?vue&type=template&id=78f3a871"
import script from "./attentionPop.vue?vue&type=script&lang=js"
export * from "./attentionPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports